export { }

function DeleteInProgressProcessAction(event: JQuery.ClickEvent) {
    let $btn: JQuery<HTMLElement> = $(event.currentTarget);
    let processActionId: number = $btn.data('processaction-id');
    let $errorSection: JQuery<HTMLElement> = $('#error-display');

    $errorSection.hide();

    $btn.prop('disabled', true);

    $.ajax({
        method: 'POST',
        url: window.ETDR_RD.appConfig['UrlAction.DeleteProcessAction'],
        data: {
            id: processActionId
        },
        headers: { Accept: 'application/json' }
    }).done((data) => {
        if (data.success) {
            let grid: MVCxClientGridView = window['InProgressProcessActionListPartial'] as MVCxClientGridView;
            grid.Refresh();
        } else {
            $errorSection.text(data.message).show();
        }
    }).fail((jqXHR: JQueryXHR) => {
        // Client <-> Server communication error. The frontend server threw an exception (e.g. 404, internal server error, etc)
        $errorSection.html(jqXHR.responseText);
        $errorSection.show();
    }).always(() => {
        $btn.prop('disabled', false);
    });
}

jQuery(() => {
    $(document).on('click', '.inpr-processaction-delete-btn', (event: JQuery.ClickEvent) => {
        DeleteInProgressProcessAction(event);
    });
});
